import script from "./DMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./DMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./DMultiSelect.vue?vue&type=style&index=0&id=13d1a44a&lang=css"

const __exports__ = script;

export default __exports__